/**
 * Scripts
 */
import 'vite/modulepreload-polyfill'
// Must stay above the lazysizes import — see src/js/lazysizesConfig.js
import './js/lazysizesConfig'
import 'lazysizes'
import { startupTheme } from './js/theme'

// Import modules — references before stack: the lift of the reference slides
// sets their height, and on load and resize stack.js has to read the final one
import './js/references'
import './js/stack'
import './js/accordion'
import './js/header'
import './js/heroGallery'
import './js/sectionsNav'
import './js/reveal'
import './js/quoteForm'
import './js/cookieBanner'

import './sass/main.sass'

/**
 * Start Theme
 */
startupTheme()

// Background videos stay still for people who asked for less motion
if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.querySelectorAll('video[autoplay]').forEach((video) => {
    video.removeAttribute('autoplay')
    video.pause()
  })
}
